export const FEED_SIZE_ATTR = 'data-feed-key';

/** Collect offsetHeights from premeasure wrappers keyed by data-feed-key. */
export const collectFeedSizes = (root: ParentNode): Map<string, number> => {
    const sizes = new Map<string, number>();
    root.querySelectorAll(`[${FEED_SIZE_ATTR}]`).forEach((node) => {
        const key = node.getAttribute(FEED_SIZE_ATTR);
        if (!key || !(node instanceof HTMLElement)) return;
        sizes.set(key, node.offsetHeight);
    });
    return sizes;
};
